import React, { useRef } from "react";
import poster1 from './Image/nv1.PNG';
import poster2 from './Image/nv2.PNG';
import poster3 from './Image/nv3.PNG';

const ContentNews = () => {
  const data = [
    {
      title: `Florida sues OpenAI, alleging it's unsafe for children`,
      link: ["https://backend.whalesai.com/public/hiwvideos/1080-1080-news-video.mp4"],
      level: '1:1 1080 X 1080 PX',
      poster: poster1,
    },
    {
      title: "What is a blue moon? Everything to know before the upcoming celestial event",
      link: ["https://backend.whalesai.com/public/hiwvideos/1920-1080-news-video.mp4"],
      level: '16:9 1920 X 1080 PX',
      poster: poster2,
    },
    {
      title: "Google's AI is being manipulated. The search giant is quietly fighting back",
      link: ["https://backend.whalesai.com/public/hiwvideos/1080-1920-news-video.mp4"],
      level: '9:16 1080 X 1920 PX',
      poster: poster3,
    }
  ];

  const videoRefs = useRef([]);

  const handlePlay = (index) => {
    videoRefs.current.forEach((video, i) => {
      if (i !== index && video) {
        video.pause();
      }
    });
  };

  return (
    <div className="text-white">
      <div>
        {data.map((video, index) => (
          <div key={index} className="text-center">
            <p>{video.title}</p>
            <p>{video.level}</p>
            {video.link.map((i, j) => (
              <div
                key={j}
                style={{ marginBlock: "20px" }}
                className="d-flex gap-2 flex-column justify-content-center align-items-center mx-auto"
              >
                <video
                  controls
                  playsInline
                  poster={video.poster}
                  src={i}
                  className="comic-video"
                  type="video/mp4"
                  ref={(el) => (videoRefs.current[index] = el)}
                  onPlay={() => handlePlay(index)}
                />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContentNews;
